
import { fetchAuthSession } from 'aws-amplify/auth';
import { BedrockAgentRuntimeClient, InvokeAgentCommand } from "@aws-sdk/client-bedrock-agent-runtime"

const GeneratePageImagePrompt = async (story, pageNumber, style) => {
    const session = await fetchAuthSession()
    // console.log(session)
    // console.log(style)
    // console.log(pageNumber)

    const bedrockClient = new BedrockAgentRuntimeClient({
        region: 'us-east-1',
        credentials: session.credentials
    });

    // let prompt = "You are working in tandem with an image model to develop illustrations for a children's book. I will provide you the text from recent pages of the book. I want you to generate a prompt that describes the setting so that an image model can generate the illustration.";
    // prompt += "The prompt should specify that the image should be in the " + style + " image style.";
    // prompt += "The prompt you generate should provide details of the relevant characters in the respective setting captured in the latest page of the book. It should focus on the scene from the latest page describing details that are relvant.";

    let prompt = "Pretend the last page of the book is really happening. Describe it to a blind person. "

    prompt += "Here is the general setting of the book: " + story.setting;

    if (pageNumber !== 0) {
        prompt += " Here is the book text up to the current page ";
        for (let i = 0; i < pageNumber; i++) {
            prompt += story.pages[i].text + " ";
        }
    }

    prompt += " Make sure you only use a single paragraph. Capture character details. Focus on providing the last setting first since it is most relevant. Make sure that the prompt will pass prompt check AUP or AWS Responsible AI Policy."
    // const concisePrompt = prompt.slice(0, 199)
    // console.log(prompt);

    const id = story.id ?? crypto.randomUUID();
    const params = {
        sessionId: id,
        agentId: "6SB5IAJLML",//"XUJQQWIVLQ", // TODO: make .env
        agentAliasId: "CWJK9MYJFW",//"2MX1RREMNI",
        inputText: prompt
    }
    try {
        const command = new InvokeAgentCommand(params);
        const response = await bedrockClient.send(command);
        // console.log('Response from Bedrock agent:', response);
        let completion = ""

        /*     for await (const chunk of stream) {
                console.log(chunk)
            } */

        let decoder = new TextDecoder("utf-8")
        for await (const chunk of response.completion) {
            // console.log("chunk:", chunk)
            const text = decoder.decode(chunk.chunk.bytes)
            completion += text
            // console.log(text)
        }

        return completion
    } catch (error) {
        console.error('Error calling Bedrock agent:', error);
    }
};

export default GeneratePageImagePrompt;